<template>
  <div>
    <div class="top-banner" :style="'background-image:url('+signUpImg+');'"></div>
    <div class="text-info">
      这里是投票简介模块前台说明：投票是需要根据投票资格来限定投票次数。 投票资格的四个类型在后台可以配置。如果是不允许的投票角色，
      则提示资格说明。比如说不允许匿名。 投票则提示：【匿名游客不能参与投票，关注公众号每天可投2票，注册用户每天可投3票，实名认证用户每一可投5票】 
      多张图片时，图片可以左右滑动。图片上传时要求压缩图片，压缩后的图片应不大于1M（在系统中可配置该限制参数）
    </div>
    <div class="form-item">
      <div class="fori-title">报名人或代理人姓名</div>
      <div>
        <van-field class="my-input" v-model="formData.name"/>
      </div>
    </div>
    <div class="form-item">
      <div class="fori-title">联系人电话</div>
      <div>
        <van-field class="my-input" v-model="formData.phone"/>
      </div>
    </div>
    <div class="form-item">
      <div class="fori-title">报名主体介绍</div>
      <div>
        <van-field type="textarea" class="my-input" v-model="formData.description"/>
      </div>
    </div>
    <UodateFile @onSuccess="uploadSuc"/>
    <div class="flex_c_m foorl-btn">
      <van-button type="default" class="btn-green" @click="formSub">确认报名</van-button>
    </div>
  </div>
</template>

<script>
import UodateFile from '@components/UodateFile'
import {setLocal,getLocal} from '@utils/tools.js'
export default {
  data(){
    return{
      formData:{
        voteId:'',
        name:'',
        phone:'',
        description:'',
        url:'',
        openid:''
      },
	  signUpImg:''
    }
  },
  components:{
    UodateFile
  },
  mounted(){
	// 获取主题详情
	this.$api.lineVote.getZhutiDetail({
		code: this.$route.query.voteCode
	}, res => {
		this.signUpImg =  res.data.signUpImg;
		this.formData.voteId =  res.data.id;
	})
  },
  methods:{
    formSub(){
      let uinfo = getLocal({key:'userInfo',parse:true});
      if(uinfo){
        this.formData.openid = uinfo.wx.openid;
      }else{
        this.$toast('请先登录！');
        return;
      }
      this.$api.signUp.setSignup(this.formData,res=>{
        this.$toast('报名成功，正在跳转到投票页...');
        setTimeout(() => {
          this.$router.push({path:'/lineVote',query:{voteCode:this.$route.query.voteCode}});
        }, 1000);
      })
    },
    // 上传成功回调
    uploadSuc(e){
      this.formData.url = e;
    }
  }
}
</script>

<style lang="scss" scoped>
.top-banner{
  width: 100%;
  height: 200px;
  background: url('../../assets/images/img/Group 5.png') no-repeat;
  background-size: 100% 100%;
}
.text-info{
  margin: 20px 15px;
  font-size:14px;
  line-height:21px;
  color: #666;
}
.form-item{
  margin: 0 25px 20px 25px;
  font-size: 14px;
  color: #666;
  .fori-title{
    margin-bottom: 8px;
  }
}
.foorl-btn{
  margin-bottom: 50px;
  .btn-green{
    width: 295px;
  }
}
</style>

<style lang="scss">
.my-input{
  padding: 0;
  .van-field__control{
    border:solid 1px #38C7B4;
    height: 45px;
    border-radius:7px;
    padding: 0 15px;
  }
}
</style>